import CityTally from './CityTally';
import AwardsDataBuilder from './AwardsDataBuilder';

class AwardsOfficeData extends AwardsDataBuilder {
  constructor(data = {}, totals = {}) {
    super(data, totals, AwardsOfficeData.buildCitiesTallyObservable);
  }

  get Cities() {
    return this.results;
  }

  static buildCitiesTallyObservable(data) {
    return Object.entries(data)
      .map(([city, cityData]) => CityTally.fromObjectObservable(cityData, city));
  }
}

export default AwardsOfficeData;
